import React, { useRef, useState } from "react";
import { IconClose, IconSource } from "../../../components/Ui/Icon";
import LoadingOverlay from "../../../components/Ui/LoadingOverlay";

import { toast } from "react-toastify";

import { adminCreateSlide, adminUpdateSlide } from "../../../services/slide";

const Create = ({ togglePopup, onSubmited, data }) => {
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(data?.url || null);

  const [file, setFile] = useState();
  const [formValue, setFormValue] = useState(
    data
      ? data
      : {
          title: "",
          order: 0,
          link: "",
        }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((preValue) => ({
      ...preValue,
      [`${name}`]: value,
    }));
  };
  const handleUpload = (event) => {
    const file = event.target.files[0];
    setFile(file);
    if (file) {
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(null);
    }
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    const callAPI = async () => {
      setLoading(true);

      try {
        if (data && data._id) {
          await adminUpdateSlide(data._id, formValue);
        } else {
          const formData = new FormData();
          formData.append("uploads", file);
          formData.append("title", formValue.title);
          formData.append("order", formValue.order);
          formData.append("link", formValue.link);
          await adminCreateSlide(formData);
        }
        setTimeout(() => {
          setLoading(false);
        });
        toast.success("Successfully");
        togglePopup();
        onSubmited();
      } catch (error) {
        toast.error(error?.response?.data?.message);
        setLoading(false);
      }
    };
    callAPI();
  };

  const handleOpenImageInput = () => {
    fileInputRef.current.click();
  };

  return (
    <div>
      {loading && <LoadingOverlay />}
      <div className="modal flex overflow-y-auto overflow-x-hidden fixed inset-0 bg-gray-700 bg-opacity-75 z-[6] justify-center items-center w-full max-h-full">
        <div
          className="relative p-4 w-full max-w-4xl max-h-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
              <h3 className="text-xl font-semibold text-black dark:text-white">
                Create Slide
              </h3>
              <button
                type="button"
                className="z-[7] text-gray-400 bg-transparent hover:bg-gray-200 hover:text-black rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                onClick={togglePopup}
              >
                <IconClose />
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            <div className="p-4 md:p-5 space-y-4">
              <div className="flex flex-col md:flex-row w-full">
                <div className="w-full p-4 overflow-x-auto shadow-md shadow-slate-300">
                  <form
                    onSubmit={(e) => onSubmitHandler(e)}
                    className="grid gap-4 sm:grid-cols-2 sm:gap-6 [&_input]:outline-none [&_textarea]:outline-none"
                  >
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="title"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Title
                      </label>
                      <input
                        type="text"
                        name="title"
                        value={formValue.title}
                        onChange={handleChange}
                        placeholder="Title"
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="sm:col-span-1">
                      <label
                        htmlFor="order"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Sort
                      </label>
                      <input
                        type="number"
                        name="order"
                        value={formValue.order}
                        onChange={handleChange}
                        placeholder="Sort"
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="link"
                        className="block mb-2 text-sm font-medium text-black dark:text-white text-start"
                      >
                        Link
                      </label>
                      <input
                        type="text"
                        name="link"
                        value={formValue.link}
                        onChange={handleChange}
                        placeholder="Link"
                        className="shadow-sm bg-gray-50 border border-gray-300 text-black sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
                    </div>
                    {!data && (
                      <div className="sm:col-span-1">
                        <button
                          disabled={loading}
                          type="button"
                          onClick={() => handleOpenImageInput()}
                          className="inline-flex gap-2 text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          <IconSource className="size-5" />
                          <span> Upload Image</span>
                        </button>
                        <input
                          hidden
                          type="file"
                          ref={fileInputRef}
                          onChange={handleUpload}
                          accept="image/*"
                        />
                      </div>
                    )}
                    {previewUrl && (
                      <img
                        src={previewUrl}
                        alt="Preview"
                        className="mt-2 rounded shadow max-h-40"
                      />
                    )}
                    <div className="flex justify-center sm:col-span-2">
                      <button
                        disabled={loading}
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
